import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useCardActionsStore = defineStore('cardActions', () => {
  const _fetchPagePrices = ref(null)
  const _fetchFilteredPrices = ref(null)
  const _reloadCards = ref(null)
  const _fetchPageBlueprints = ref(null)
  const _fetchFilteredBlueprints = ref(null)
  const _updateAllListings = ref(null)
  const _applyBulkMultiplier = ref(null)
  const _checkCtPrices = ref(null)

  function registerFetchPagePrices(fn) { _fetchPagePrices.value = fn }
  function registerFetchFilteredPrices(fn) { _fetchFilteredPrices.value = fn }
  function registerReloadCards(fn) { _reloadCards.value = fn }
  function registerFetchPageBlueprints(fn) { _fetchPageBlueprints.value = fn }
  function registerFetchFilteredBlueprints(fn) { _fetchFilteredBlueprints.value = fn }
  function registerUpdateAllListings(fn) { _updateAllListings.value = fn }
  function registerApplyBulkMultiplier(fn) { _applyBulkMultiplier.value = fn }
  function registerCheckCtPrices(fn) { _checkCtPrices.value = fn }

  function fetchPagePrices() { _fetchPagePrices.value?.() }
  function fetchFilteredPrices() { _fetchFilteredPrices.value?.() }
  function reloadCards() { _reloadCards.value?.() }
  function fetchPageBlueprints() { _fetchPageBlueprints.value?.() }
  function fetchFilteredBlueprints() { _fetchFilteredBlueprints.value?.() }
  function updateAllListings() { _updateAllListings.value?.() }
  function applyBulkMultiplier(mult) { _applyBulkMultiplier.value?.(mult) }
  function checkCtPrices() { _checkCtPrices.value?.() }

  return {
    registerFetchPagePrices, registerFetchFilteredPrices, registerReloadCards,
    registerFetchPageBlueprints, registerFetchFilteredBlueprints, registerUpdateAllListings, registerApplyBulkMultiplier, registerCheckCtPrices,
    fetchPagePrices, fetchFilteredPrices, reloadCards, fetchPageBlueprints, fetchFilteredBlueprints, updateAllListings, applyBulkMultiplier, checkCtPrices,
  }
})
